import { UserType } from 'src/shared/store/user/types';

export const canManageModel = (user: UserType | null): boolean =>
  Boolean(user?.isAdmin || user?.isDeveloper);

export const canWriteData = (user: UserType | null): boolean =>
  Boolean(user?.isAdmin || user?.isOperator);

export const canAccessGroups = (user: UserType | null): boolean => Boolean(user?.isAdmin);
